import { PersonShow } from '../persons/show';

export const LectorShow = () => (
  <PersonShow resource="user_catalog.lectors" ns="user_catalog.lectors" />
);
